import { useEffect } from "react";
import { navigate } from "gatsby";

export default ({ data, pageContext }) => {
  useEffect(() => {
    navigate(pageContext.redirect);
  }, [pageContext]);
  return null;
};
